// Generated by genversion.
export const version = '1.7.0';
